(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputRadio', cpInputRadio);

    cpInputRadio.$inject = [];

    function cpInputRadio() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-radio/input-radio.html',
            scope: {
                title: '@',
                fullWidth: '@',
                object: '=',
                prop: '@',
                options: '=',
                optionPropTitle: '@',
                optionPropValue: '@',
                isRequired: '=?',
                isDisabled: '=?',
                onChange: '&?',
                onFirstSelect: '&?'
            },
            link: function(scope, element, attrs, controller) {
                scope.isSelected = isSelected;
                scope.runOnChange = runOnChange;

                function isSelected(option) {
                    return scope.object[scope.prop] === option[scope.optionPropValue];
                }

                function runOnChange(newV, oldV) {
                    if (oldV) {
                        if (scope.onChange) {
                            scope.onChange();
                        }
                    } else {
                        if (scope.onFirstSelect) {
                            scope.onFirstSelect();
                        }
                    }
                }
            }
        };
    }
})();
